<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Словари</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="additional.link_name"
                            label="Cсылка на сайт - название"
                            placeholder="Введите название ссылки на сайт"
                        />
                        <CInput
                            v-model="additional.link"
                            label="Cсылка на сайт - ссылка"
                            placeholder="Введите ссылку на сайт"
                        />
                        <CInput
                            v-model="additional.main_link"
                            label="Основная ссылка"
                            placeholder="Введите ссылку"
                        />
                        <CInput
                            v-model="additional.address"
                            label="Адрес"
                            placeholder="Введите адрес"
                        />
                        <CInput
                            v-model="additional.title"
                            label="Заголовок описания"
                            placeholder="Введите заголовок описания"
                        />
                        <CInput
                            v-model="additional.description"
                            label="Описание"
                            placeholder="Введите описание"
                        />
                        <CInput
                            v-model="additional.services_title"
                            label="Заголовок списка услуг"
                            placeholder="Введите заголовок списка услуг"
                        />
                        <label>Время мероприятия:</label>
                        <CRow style="padding-left:20px">
                            <span>С</span>
                            <CCol
                                cols="12"
                                md="4"
                                class="mt-0 mb-1">
                                <CInput
                                    v-model="additional.event_time_from"
                                    type="time"/>
                            </CCol>
                            <span>До</span>
                            <CCol
                                cols="14"
                                md="4"
                                class="mt-0 mb-1">
                                <CInput
                                    v-model="additional.event_time_to"
                                    type="time"/>
                            </CCol>
                        </CRow>
                        <label>Дата мероприятия:</label>
                        <CRow style="padding-left:20px">
                            <span>C</span>
                            <CCol
                                cols="12"
                                md="4"
                                class="mt-0 mb-1">
                                <DatePicker
                                    v-model="datepicker.dateFrom"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="form-control custom-datepicker"
                                    placeholder="Дата" />
                            </CCol>
                            <span>До</span>
                            <CCol
                                cols="12"
                                md="4"
                                class="mt-0 mb-1">
                                <DatePicker
                                    v-model="datepicker.dateTo"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="form-control custom-datepicker"
                                    placeholder="Дата" />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 mb-4" style="margin-top:20px">
                            <CButton
                                color="light"
                                class="mr-3"
                                @click="resetDate"
                            >Сброс дат и времени</CButton>
                        </CRow>
                        <br>
                        <CRow v-if="additional.logo">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl"
                                class="m2"
                                width="200"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Логотип"
                            horizontal
                            @change="selectPicture"
                        />
                        <EntityAdditionalPictures
                            :pictures="additional.pictures"
                            :entity-id="+$route.params.id"
                            :additional-id="additional.id"
                            @pictures-update="fetch"
                        />

                        <EntityAdditionalBanners
                            :banners="additional.banners"
                            :entity-id="+$route.params.id"
                            :additional-id="additional.id"
                            @banners-update="fetch"
                        />
                    </CForm>

                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import moment from 'moment';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import EntityAdditionalPictures from '@/components/entities/EntityAdditionalPictures';
    import EntityAdditionalBanners from '@/components/entities/EntityAdditionalBanners';



    export default {

        name: 'EntityAdditional',

        components: {
            EntityTabLinks,
            EntityAdditionalPictures,
            EntityAdditionalBanners,
            DatePicker
        },

        data: () => ({
            additional: {
                id: null,
                entity_id: null,
                link: '',
                link_name: '',
                main_link: '',
                logo: '',
                address: '',
                title: '',
                description: '',
                services_title: '',
                pictures: [],
                banners: [],
                event_date_from: '',
                event_date_to: '',
                event_time_from: '',
                event_time_to: '',
            },
            isCreated: false,
            selectedPicture: null,
            datepicker: {
                lang: ru,
                format: 'dd.MM.yyyy',
                dateFrom: null,
                dateTo: null,
            },
        }),

        computed: {
            pictureUrl() {
                if (this.additional.logo) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.additional.logo
                    );
                } else {
                    return '';
                }
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id;
                try {
                    const additional = await this.axios.get(`/entities/${id}/additional`);
                    if (additional.data.id) {
                        this.additional = additional.data;
                        this.isCreated = true;
                    }
                    if(additional.data.event_date_from) {
                        this.datepicker.dateFrom = moment(additional.data.event_date_from).format('YYYY-MM-DD');
                        this.additional.event_date_from = moment(additional.data.event_date_from).format('YYYY-MM-DD');
                    }
                    if(additional.data.event_date_to) {
                        this.datepicker.dateTo = moment(additional.data.event_date_to).format('YYYY-MM-DD');
                        this.additional.event_date_to = moment(additional.data.event_date_to).format('YYYY-MM-DD');
                    }
                    this.additional.event_time_from = additional.data.event_time_from
                            ? moment('Mon Jun 28 2021 ' + additional.data.event_time_from).format('HH:mm')
                            : null;
                    this.additional.event_time_to = additional.data.event_time_to
                            ? moment('Mon Jun 28 2021 ' + additional.data.event_time_to).format('HH:mm')
                            : 0;
                } catch (error) { console.log(error); }
                this.additional.entity_id = +id;
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            async save() {
                try {
                    let formData = new FormData();
                    if (this.selectedPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPicture);
                        const uploadPicture = await this.axios.post('/files/upload', formData);
                        this.additional.logo = uploadPicture.data.filename;
                    }
                    this.additional.event_date_from = this.datepicker.dateFrom ? moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD') : null;
                    this.additional.event_date_to = this.datepicker.dateTo ? moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD') : null;
                    this.additional.event_time_from = this.additional.event_time_from
                        ? moment(this.additional.event_time_from, 'HH:mm').format('HH:mm')
                        : null;
                    this.additional.event_time_to = this.additional.event_time_to
                        ? moment(this.additional.event_time_to, 'HH:mm').format('HH:mm')
                        : null;

                    await this.axios.post(`/entities/${this.$route.params.id}/additional`,this.additional);

                    this.goBack();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router
                    .push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
            },
            resetDate() {
                this.datepicker.dateFrom = null;
                this.datepicker.dateTo = null;
                this.additional.event_time_from = null;
                this.additional.event_time_to = null;
            },
        },
    };
</script>
<style>
.custom-datepicker.form-control:disabled, .custom-datepicker.form-control[readonly] {
    background-color: #ffffff;
}
</style>
